var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFoodDairy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 61.3",
    style: {
      enableBackground: "new 0 0 50 61.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F2F3F4;}\n\t.st1{opacity:0.3;fill:#040505;enable-background:new    ;}\n\t.st2{fill:#13B3DC;}\n\t.st3{fill:#FFFFFF;}\n\t.st4{fill:#D9D9D9;}\n\t.st5{opacity:0.3;}\n\t.st6{fill:#040505;}\n\t.st7{fill:#1A1818;}\n\t.st8{opacity:0.5;fill:#FFFFFF;enable-background:new    ;}\n\t.st9{fill:#E8A70A;}\n\t.st10{fill:#FFD647;}\n\t.st11{opacity:0.2;}\n\t.st12{fill:#DD6016;}\n\t.st13{fill:#E17F14;}\n\t.st14{fill:#FFD344;}\n\t.st15{fill:#FFD133;}\n\t.st16{fill:#F8C015;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1212",
    transform: "translate(-65.758 -37.997)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1188",
    transform: "translate(82.456 38.149)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3606",
    className: "st0",
    d: "M20.8,0.8v2.5H6.1V0.8C6.1,0.3,6.4,0,6.8,0H20C20.5,0,20.8,0.3,20.8,0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3607",
    className: "st1",
    d: "M20.8,0.8v2.5H6.1V0.8C6.1,0.3,6.4,0,6.8,0H20C20.5,0,20.8,0.3,20.8,0.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_584",
    x: 0.8,
    y: 8.5,
    className: "st2",
    width: 14.7,
    height: 45.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3608",
    className: "st3",
    d: "M15.5,8.5H0.8l5.3-5.3h14.7L15.5,8.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_585",
    x: 15.5,
    y: 8.5,
    className: "st2",
    width: 10.6,
    height: 45.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3609",
    className: "st4",
    d: "M26.1,8.5H15.5l3.4-3.4l1.9-1.9L26.1,8.5z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1184",
    transform: "translate(15.479 3.253)",
    className: "st5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3610",
    className: "st6",
    d: "M10.6,5.3H0l3.4-3.4L5.3,0L10.6,5.3z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3611",
    className: "st4",
    d: "M26.1,8.5H15.5l3.4-3.4L26.1,8.5z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1185",
    transform: "translate(0 17.522)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3612",
    className: "st0",
    d: "M26,1.4l0.2,20.1c-1.4-0.7-5.3,4.4-10.6,0.1S4.6,22.6,0.8,22.6H0.8v-16 C2.3,5.7,9.4-1.6,15.5,5c3.6,3.9,8-5,10.4-5C25.9,0,25.9,1.4,26,1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3613",
    className: "st7",
    d: "M2.8,6.1L1.7,7L1.6,7.1c0,0,0,0,0,0v0.4l0,2.7c0,1-0.1,1.9-0.1,2.9c0,0.7,0,1.5,0,2.2 c0.1,1.1,0.1,2.2,0,3.3c0,0.4,0,0.8,0,1.2c0,0.5,0.1,0.9,0.1,1.4l0,0.3l0,0.2c0,0,0,0,0,0c0,0-0.1,0.1-0.1,0.1 c0,0.1,0.1,0.1,0.1,0.1l0.1,0l0.2,0c0.1,0,0.3-0.1,0.4-0.1c0.5-0.2,1.1-0.4,1.6-0.6c1.1-0.4,2.1-0.8,3.2-1.2 c1-0.4,2.1-0.6,3.2-0.8c1-0.1,2,0,2.9,0.3c0.8,0.3,1.6,0.6,2.2,1.1l0.9,0.6c0.3,0.2,0.6,0.4,0.9,0.5c0.6,0.3,1.3,0.5,1.9,0.6 c1.4,0.1,2.8-0.2,4-0.9c0.5-0.2,0.9-0.5,1.5-0.8c0.2-0.1,0.4-0.2,0.6-0.3c0,0,0,0,0,0s0,0,0,0s0,0,0-0.1c0-0.2,0-0.5,0-0.7 c-0.1-2.2,0.1-4.5-0.1-6.7c-0.1-1.1,0-2.3,0.1-3.4c0.1-1.4,0.2-2.7,0.2-4.1L25.7,2c0-0.2,0-0.4,0-0.5c0-0.1,0-0.1,0.1-0.2 c0,0,0.1,0,0.1,0.1c0.2,0.5,0.3,1,0.4,1.6c0,1.4,0.1,2.8,0.1,4.2l0.1,8c0,1.2,0.1,2.4,0.1,3.6l0.1,2.6l-0.2,0.2l-0.1,0.1l-0.1,0 c-0.2,0.1-0.4,0.2-0.6,0.3c-1.4,0.6-3.2,1.9-5.2,2c-1.9,0.1-3.8-0.5-5.3-1.7c-1.3-1.1-3-1.7-4.7-1.6c-1.8,0.2-3.6,0.7-5.2,1.5 c-0.6,0.2-1.2,0.5-1.8,0.7l-1,0.3L2,23.3c-0.3,0.1-0.5,0.1-0.8,0.1l-0.9,0c-0.1,0-0.1,0-0.2,0l0-0.2l0-0.4c0-0.3,0-0.6,0-0.9 l0-0.6l0-1.9l0.1-7.6c0-1.6,0-3.1,0.1-4.8c0-0.3-0.1-0.7,0.3-0.9l0.4-0.3l0.2-0.2l1-0.7c0.6-0.5,1.3-0.9,2-1.3 C5.7,2.6,7.6,2,9.7,1.9c1.6,0,3.2,0.5,4.4,1.5c0.2,0.1,0.3,0.2,0.5,0.3L15,4.1l0.8,0.8c0.4,0.5,1.1,0.8,1.8,0.8 c0.8-0.1,1.6-0.4,2.2-0.9c0.7-0.5,1.4-1,2-1.6l1.8-1.7c0.5-0.6,1.2-1,1.9-1.3c0.1,0,0.1,0,0.2,0c0,0,0.1,0,0.1,0c0,0,0,0.1,0,0.1 c0,0.1,0,0.3,0,0.4c0,0.2-0.1,0.4-0.2,0.6c0,0.1,0,0.1,0,0.2c0,0,0,0.1,0.1,0.2c0,0.1,0.1,0.1,0.2,0.1c0.1,0,0.1,0,0,0.1 c-0.2,0-0.3-0.1-0.4-0.3c0,0,0-0.1-0.1-0.1l-0.1-0.2c0,0-0.1-0.1-0.1-0.1c0,0-0.1,0-0.1,0c0,0-0.1,0.1-0.1,0.1 c0,0-0.1,0.1-0.2,0.2l-0.3,0.3l-0.7,0.6c-1.1,1.1-2.3,2.2-3.5,3.2c-0.3,0.2-0.6,0.5-0.9,0.7c-0.7,0.5-1.5,0.7-2.4,0.6 c-0.6-0.1-1.2-0.4-1.7-0.8l-1.1-1c-0.2-0.1-0.3-0.3-0.5-0.5l-0.5-0.4c-0.3-0.3-0.7-0.5-1.1-0.7C11.1,3,10,2.9,8.9,3.1 C6.6,3.6,4.5,4.7,2.8,6.1L2.8,6.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1186",
    transform: "translate(15.479 8.54)",
    className: "st5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_586",
    x: 0,
    y: 0,
    className: "st6",
    width: 10.6,
    height: 45.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1187",
    transform: "translate(1.849 28.075)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3614",
    className: "st2",
    d: "M4,0.2v5.6C4,5.9,4,6,3.8,6H3.7C3.5,6,3.4,5.9,3.4,5.8V1.7l0,0l-1,2.6c0,0.1-0.1,0.1-0.2,0.1 H1.9c-0.1,0-0.2-0.1-0.2-0.1L0.7,1.6l0,0v4.2C0.7,5.9,0.6,6,0.4,6H0.3C0.1,6,0,5.9,0,5.8V0.2C0,0.1,0.1,0,0.3,0h0.3 c0.1,0,0.3,0.1,0.3,0.2l1.1,2.7L2,3.2l0.1-0.3l1.1-2.7C3.2,0.1,3.4,0,3.5,0h0.2C4,0,4,0.1,4,0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3615",
    className: "st2",
    d: "M5.7,0.2v5.6C5.7,5.9,5.6,6,5.4,6H5.3C5.1,6,5,5.9,5,5.8V0.2C5,0.1,5.1,0,5.3,0h0.1 C5.6,0,5.7,0.1,5.7,0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3616",
    className: "st2",
    d: "M7.4,0.2v4.9h1.5C9,5.1,9,5.2,9,5.5v0.2C9,5.9,9,6,8.9,6h-2C6.8,6,6.7,5.9,6.7,5.7V0.2 C6.7,0.1,6.8,0,7,0h0.1C7.3,0,7.4,0.1,7.4,0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3617",
    className: "st2",
    d: "M12.3,0.1c0,0.1,0,0.1-0.1,0.2l-1.3,2.6l1.6,2.8c0,0,0,0.1,0,0.2C12.5,6,12.5,6,12.3,6h-0.2 c-0.1,0-0.3,0-0.3-0.1l-1.4-2.7l0,0v2.6C10.3,5.9,10.2,6,10,6H9.9C9.7,6,9.6,5.9,9.6,5.8V0.2C9.6,0.1,9.7,0,9.9,0H10 c0.2,0,0.3,0.1,0.3,0.2v2.5h0l1.3-2.6C11.6,0,11.7,0,11.9,0H12C12.2,0,12.3,0.1,12.3,0.1z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3618",
    className: "st0",
    d: "M20.6,0.8v2.5H6.1V0.8C6.1,0.3,6.4,0,6.8,0h13.1C20.3,0,20.6,0.3,20.6,0.8 C20.6,0.8,20.6,0.8,20.6,0.8z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3619",
    className: "st7",
    d: "M109.3,62.9v9.7c0,1.7-0.1,3.4-0.1,5.1c0,1.3,0,2.6,0,3.9c0.1,1.9,0.1,3.8,0,5.8 c0,0.7,0,1.5,0,2.2c0,0.5,0,1,0.1,1.4v2.2l-1.7,0l-1-0.1c-2.1-0.2-4.2,0-6.3-0.1l-2.5,0l0.6-0.6v0l0,0.6h-0.6l-3.6,0L88.8,93h-4.9 h-1.3l0-4l0-16c0-1,0-1.9-0.1-2.9c-0.1-1.2-0.1-2.4,0-3.6c0-0.4,0-0.8,0-1.2c-0.1-3.9,0.1-7.9-0.1-11.8c0-1,0-2,0-3 c0.1-1.1,0.1-2.3,0.2-3.4l0-0.4l4.1,0.2c1.2,0,2.3,0.1,3.5,0.1l6.5,0.1c0.3,0,0.6,0,0.9,0.1c0.1,0,0.2,0,0.3,0.1c0,0,0,0.1-0.1,0.1 c-0.9,0.2-1.9,0.3-2.8,0.4l-7.5,0.1l-3.8,0l0,9.3c0,2.1,0.1,4.2,0.1,6.3c0.1,5.2,0.2,10.3,0.2,15.5c0,3,0,6,0.1,8.9l0,3.8l13.9,0 l-0.8,0.8v-0.8h0.8h0.8l9.1,0.1c0-5.4,0.1-10.8,0.1-16.3c0-5.6,0.1-11.1,0.2-16.7c0-3.4,0-6.8,0.1-10.2l0-1l-5.3-5.3l0-2 c0-0.3,0-0.5,0-0.8c-0.1-0.2-0.2-0.3-0.4-0.3l-3.6,0l-9.2-0.2c-0.3,0-0.7-0.1-0.9,0.2c-0.3,0.2-0.2,0.6-0.2,0.9l0,2.1l0,0l-3.3,3.2 c-0.6,0.7-1.3,1.2-2.1,1.8c-0.3,0.2-0.4,0.1-0.1-0.3c0.2-0.3,0.5-0.6,0.7-0.9c0.7-0.7,1.4-1.5,2.1-2.2l1.1-1.1l0.5-0.5l0.3-0.3 c0,0,0,0,0.1,0l0,0c0,0,0,0.1,0-0.2l0.1-2.1c0.1-0.6,0.5-1.1,1.1-1.3c0.1,0,0.3,0,0.4,0h0.3l0.5,0l4.1,0.1c0.6,0,1.3,0,1.9-0.1 c1.2,0,2.4-0.1,3.6-0.1l1.6,0h0.8h0.2c0.1,0,0.2,0,0.4,0c0.3,0,0.5,0.1,0.7,0.3c0.4,0.3,0.6,0.8,0.6,1.3v0.8l0,0.8v0.4 c0,0.1,0,0,0,0.1l2.4,2.5l1.3,1.3l1.5,1.5c0,1,0,2,0,3.1L109.3,62.9L109.3,62.9z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1211",
    transform: "translate(66.71 78.119)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3620",
    className: "st8",
    d: "M0.3,16.3L0.3,16.3c-0.1,0-0.1,0-0.1-0.1v0C0,14.8,0,4.5,0,4.5l0.1,0v0.2 C0.1,6.1,0.1,15,0.3,16.3L0.3,16.3z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1210"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3621",
    className: "st9",
    d: "M0.3,16.3L0.3,16.3L0.3,16.3C0.3,16.3,0.2,16.3,0.3,16.3l-0.1-0.1c0,0,0,0,0,0l0,0v0v0 C0,14.9,0,6.3,0,4.7V4.5L8.4,6l8.1,1.5l5.7,1.1l0,0l0,0.1c0,0.1,0.1,0.2,0.1,0.3c0,0.1,0.1,0.1,0.1,0.2v2.3 c-0.3,0.1-0.5,0.4-0.4,0.7c0,0,0,0,0,0.1s0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0.1c0,0,0,0,0,0.1l0,0l0,0c0,0,0,0,0,0c0,0,0,0,0,0.1 l0,0l0,0c0,0.1,0.1,0.1,0.2,0.2c0,0,0.1,0,0.1,0v4.9c-0.1,0.1-0.2,0.2-0.2,0.3c0,0,0,0,0,0v0l0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0.1,0.1,0.1c0,0,0.1,0,0.1,0.1v1.6c0,0.3-0.2,0.6-0.5,0.6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1189",
    transform: "translate(0.195 8.602)",
    className: "st5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3622",
    className: "st6",
    d: "M12.9,10.2L5.6,8.8L2.8,8.3L0.1,7.7C0.1,7.7,0,7.7,0,7.6l0,0l2.7,0.5l2.8,0.5L12.9,10.2 l3.2,0.5l5.6,1.1c0.3-0.1,0.5-0.3,0.5-0.6V9.6c0,0,0.1,0,0.1,0.1v1.6c0,0.3-0.2,0.6-0.5,0.6L16,10.8L12.9,10.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3623",
    className: "st6",
    d: "M22.3,0.5v2.3c-0.3,0.1-0.5,0.4-0.4,0.7c0,0,0,0,0,0.1s0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0.1 c0,0,0,0,0,0.1l0,0l0,0c0,0,0,0,0,0c0,0,0,0,0,0.1l0,0c-0.2-0.1-0.3-0.3-0.3-0.6c0-0.3,0.2-0.6,0.4-0.7V0.4c0,0,0-0.1,0-0.1 c0-0.1,0-0.1-0.1-0.2c0,0,0-0.1-0.1-0.1l0,0l0,0.1c0,0.1,0.1,0.2,0.1,0.3C22.3,0.4,22.3,0.5,22.3,0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3624",
    className: "st6",
    d: "M22.2,4.1C22.2,4.1,22.3,4.1,22.2,4.1l0.1,5c-0.1,0.1-0.2,0.2-0.2,0.3c0,0.1,0,0.1,0.1,0.2 C22,9.5,22,9.4,22,9.3c0-0.1,0.1-0.3,0.2-0.3L22.2,4.1z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3625",
    className: "st10",
    d: "M22.3,8.6L22.3,8.6L22.3,8.6l-5.7-1.1L8.4,6L0,4.4c0.1-0.1,0.2-0.2,0.3-0.2 c6-4.4,14-4.3,15.2-4.2c0.1,0,0.2,0,0.2,0.1l0.4,0.5C16.1,0.8,16,0.9,16,1c0,0.3,0.2,0.6,0.5,0.7c0.1,0.1,0.3,0.1,0.4,0.1 c0,0,0.1,0,0.1,0l2.7,3.5L20,5.6c-0.2,0.2-0.4,0.5-0.4,0.8c0.1,0.7,0.7,1.2,1.3,1.1c0.1,0,0.2,0,0.3,0c0,0,0,0,0,0 c0,0,0.1,0,0.1,0L22,8.3L22.3,8.6z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1190",
    transform: "translate(15.513 0.019)",
    className: "st11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3626",
    className: "st6",
    d: "M0,0L0,0c0.1,0,0.2,0,0.2,0.1l0.4,0.5C0.5,0.7,0.5,0.9,0.5,1c0,0.3,0.1,0.5,0.3,0.6 c0,0-0.1,0-0.1,0C0.5,1.5,0.3,1.2,0.3,0.9c0-0.1,0-0.3,0.1-0.4L0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3627",
    className: "st6",
    d: "M4,5.2L1.4,1.8c0,0,0.1,0,0.1,0l2.7,3.5l0.2,0.3C4.2,5.8,4.1,6.1,4.1,6.3 c0,0.4,0.2,0.7,0.5,0.9c-0.4-0.1-0.7-0.5-0.8-1c0-0.3,0.1-0.6,0.4-0.8L4,5.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3628",
    className: "st6",
    d: "M6.8,8.6L6.8,8.6L6.4,8.3L6.3,8.2L5.7,7.4l0,0c0,0,0.1,0,0.1,0l0.7,0.9L6.8,8.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1191",
    transform: "translate(7.928 7.868)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3629",
    className: "st12",
    d: "M2,1.1c0,0.4-0.3,0.7-0.7,0.8C1,1.9,0.6,1.8,0.3,1.6C0,1.2-0.1,0.7,0.2,0.4 C0.5,0,0.9-0.1,1.3,0C1.7,0.1,2,0.4,2,0.8C2,0.9,2,1,2,1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3630",
    className: "st13",
    d: "M1.9,1.4C1.5,1.9,0.8,2,0.4,1.7c0,0-0.1-0.1-0.1-0.1c-0.3-0.3-0.4-0.8-0.1-1.2 c0,0,0.1-0.1,0.1-0.1C1-0.1,1.6,0.6,1.8,1.1C1.9,1.2,1.9,1.3,1.9,1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3631",
    className: "st14",
    d: "M1,1.5c0,0.1-0.1,0.1-0.2,0.1c-0.1,0-0.1-0.2-0.1-0.2c0-0.1,0.1-0.1,0.2-0.1 C1,1.3,1,1.4,1,1.5C1,1.5,1,1.5,1,1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1192",
    transform: "translate(15.213 7.991)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3632",
    className: "st12",
    d: "M2,1.1c0,0.4-0.3,0.7-0.7,0.8c-0.4,0.1-0.8,0-1.1-0.3c-0.3-0.3-0.3-0.8-0.1-1.2 C0.5,0.1,0.9-0.1,1.3,0C1.7,0.1,2,0.4,2,0.8C2,0.9,2,1,2,1.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1193",
    transform: "translate(18.169 17.268)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3633",
    className: "st12",
    d: "M1.1,0.7c0,0.1,0,0.2-0.1,0.2C0.9,1.1,0.7,1.2,0.5,1.2C0.2,1.2,0,0.8,0,0.5 c0-0.2,0.1-0.3,0.3-0.4C0.4,0,0.5,0,0.7,0C1,0.1,1.2,0.4,1.1,0.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3634",
    className: "st13",
    d: "M1.1,0.9C0.9,1.1,0.7,1.2,0.5,1.2C0.2,1.2,0,0.8,0,0.5c0-0.2,0.1-0.3,0.3-0.4 c0,0,0.1,0,0.1,0C0.8,0.2,1.1,0.5,1.1,0.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1194",
    transform: "translate(9.465 11.91)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3635",
    className: "st12",
    d: "M1.2,0.7c0,0.3-0.3,0.5-0.6,0.5c0,0,0,0,0,0c-0.3,0-0.6-0.3-0.6-0.6S0.2,0,0.6,0 c0.3,0,0.5,0.1,0.6,0.4C1.2,0.5,1.2,0.6,1.2,0.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3636",
    className: "st13",
    d: "M1.1,0.9C0.9,1.2,0.6,1.3,0.3,1.1C0.2,1.1,0.1,1,0.1,0.9C-0.1,0.6,0,0.2,0.3,0.1 C0.6,0.1,1,0.3,1,0.6C1.1,0.7,1.1,0.8,1.1,0.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1195",
    transform: "translate(14.936 15.995)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3637",
    className: "st12",
    d: "M0.7,0.4c0,0.2-0.2,0.3-0.4,0.3c0,0,0,0,0,0C0.1,0.7,0,0.5,0,0.3c0,0,0,0,0,0 C0,0.1,0.2,0,0.3,0c0.2,0,0.3,0.1,0.4,0.3C0.7,0.3,0.7,0.4,0.7,0.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3638",
    className: "st13",
    d: "M0.6,0.5C0.5,0.7,0.3,0.8,0.2,0.7C0.1,0.6,0.1,0.6,0,0.5C0,0.4,0,0.1,0.2,0.1 c0.2,0,0.4,0.1,0.4,0.3C0.6,0.4,0.6,0.5,0.6,0.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1196",
    transform: "translate(5.766 10.092)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3639",
    className: "st12",
    d: "M0.7,0.4c0,0.2-0.2,0.3-0.4,0.3c0,0,0,0,0,0C0.1,0.7,0,0.5,0,0.3C0.1,0.1,0.2,0,0.3,0 c0.2,0,0.3,0.1,0.4,0.3C0.7,0.3,0.7,0.4,0.7,0.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3640",
    className: "st13",
    d: "M0.6,0.5C0.5,0.7,0.3,0.8,0.2,0.7C0.1,0.6,0.1,0.6,0,0.5C0,0.4,0,0.1,0.2,0.1 c0.2,0,0.4,0.1,0.4,0.3C0.6,0.4,0.6,0.5,0.6,0.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1197",
    transform: "translate(19.317 13.177)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3641",
    className: "st12",
    d: "M1.2,0.7c0,0.3-0.3,0.5-0.6,0.5c0,0,0,0,0,0c-0.3,0-0.6-0.3-0.6-0.6S0.2,0,0.6,0l0,0 c0.3,0,0.5,0.1,0.6,0.4C1.2,0.5,1.2,0.6,1.2,0.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3642",
    className: "st13",
    d: "M1.1,0.9C0.9,1.2,0.6,1.3,0.3,1.1C0.2,1.1,0.1,1,0.1,0.9C-0.1,0.6,0,0.2,0.3,0.1 c0.3,0,0.6,0.2,0.7,0.5C1.1,0.7,1.1,0.8,1.1,0.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1198",
    transform: "translate(18.479 9.369)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3643",
    className: "st12",
    d: "M1.3,0.7C1.2,1,0.9,1.2,0.6,1.2C0.3,1.2,0.1,1,0.1,0.8C-0.1,0.3,0.4-0.1,0.8,0 c0.2,0,0.4,0.2,0.4,0.4C1.3,0.5,1.3,0.6,1.3,0.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3644",
    className: "st13",
    d: "M1.2,0.9C1,1.2,0.7,1.3,0.5,1.2C0.1,1.1-0.1,0.8,0,0.5c0-0.1,0.1-0.2,0.2-0.3 c0.4-0.3,0.8,0.1,1,0.5C1.2,0.7,1.2,0.8,1.2,0.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1199",
    transform: "translate(8.647 15.118)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3645",
    className: "st12",
    d: "M1.9,1.1c0,0.5-0.4,0.8-0.9,0.8c0,0,0,0-0.1,0C0.3,1.8-0.1,1.3,0,0.7 c0-0.1,0.1-0.2,0.1-0.4C0.3,0.2,0.5,0,0.7,0c0.5-0.1,1,0.3,1.2,0.8C1.9,0.9,1.9,1,1.9,1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3646",
    className: "st13",
    d: "M1.7,1.4C1.5,1.9,0.9,2,0.5,1.7C0.4,1.6,0.3,1.6,0.2,1.5c-0.3-0.4-0.3-1.1,0.1-1.3 C1-0.1,1.4,0.6,1.7,1.1C1.7,1.2,1.7,1.3,1.7,1.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1200",
    transform: "translate(1.754 7.015)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3647",
    className: "st12",
    d: "M2.1,1.1c0,0.3-0.2,0.6-0.5,0.7C1,2,0.4,1.8,0.1,1.3c-0.2-0.4-0.1-1,0.4-1.2 c0.1,0,0.1-0.1,0.2-0.1C1.2-0.1,1.8,0.1,2,0.7c0,0.1,0,0.1,0.1,0.2C2.1,1,2.1,1,2.1,1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3648",
    className: "st13",
    d: "M2,1.5C1.7,1.9,1.1,2,0.6,1.8C0.2,1.6-0.1,1.1,0.1,0.7c0-0.1,0.1-0.2,0.2-0.3 c0.3-0.2,0.6-0.3,1-0.1c0.4,0.2,0.6,0.5,0.8,0.9C2,1.3,2,1.4,2,1.5z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3649",
    className: "st13",
    d: "M14.6,7.2c0,0.1-0.1,0.3-0.2,0.4C14,7.9,13.6,8.1,13.1,8c-0.5,0-0.9-0.3-1.1-0.7 c0-0.1,0-0.2,0-0.4c0.1-0.3,0.3-0.6,0.6-0.7c0.3-0.1,0.5-0.1,0.8-0.1c0.3,0,0.6,0.1,0.8,0.3C14.5,6.7,14.6,6.9,14.6,7.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3650",
    className: "st15",
    d: "M14.6,7.2c0,0.1-0.1,0.3-0.2,0.4C14,7.9,13.6,8.1,13.1,8c-0.5,0-0.9-0.3-1.1-0.7v0 c0.1-0.4,0.4-0.7,0.8-0.8c0.3-0.1,0.6-0.2,1-0.1c0.2,0,0.4,0.1,0.5,0.1C14.5,6.7,14.6,6.9,14.6,7.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3651",
    className: "st3",
    d: "M13.9,7.4c0,0-0.1,0.1-0.1,0c0,0,0-0.1,0-0.1C13.8,7.4,13.8,7.3,13.9,7.4 C13.9,7.4,13.9,7.4,13.9,7.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3652",
    className: "st13",
    d: "M7.4,5.8C7.4,5.9,7.3,6,7.3,6C7.1,6.2,6.8,6.3,6.5,6.3C6.2,6.3,6,6.1,5.9,5.9 c0-0.1,0-0.1,0-0.2c0.1-0.2,0.2-0.3,0.4-0.4c0.2-0.1,0.3-0.1,0.5-0.1c0.2,0,0.4,0.1,0.5,0.2C7.4,5.5,7.4,5.6,7.4,5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3653",
    className: "st15",
    d: "M7.4,5.8C7.4,5.9,7.3,6,7.3,6C7.1,6.2,6.8,6.3,6.5,6.3C6.2,6.3,6,6.1,5.9,5.9l0,0 c0.1-0.2,0.2-0.4,0.5-0.5c0.2-0.1,0.4-0.1,0.6-0.1c0.1,0,0.2,0,0.3,0.1C7.4,5.5,7.4,5.6,7.4,5.8z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1201",
    transform: "translate(3.719 12.28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3654",
    className: "st12",
    d: "M2.9,1.7c0,0.2-0.1,0.4-0.2,0.5C2.6,2.2,2.6,2.3,2.5,2.4C2.1,2.8,1.5,2.9,1,2.6 C0.3,2.4-0.1,1.7,0,1c0-0.1,0-0.1,0.1-0.2c0.1-0.3,0.3-0.5,0.6-0.6C0.8,0.1,0.9,0.1,1,0c0.4-0.1,0.9,0,1.3,0.3 c0.1,0.1,0.2,0.1,0.2,0.2c0.2,0.2,0.4,0.5,0.4,0.9C2.9,1.5,2.9,1.6,2.9,1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3655",
    className: "st13",
    d: "M2.7,2.2C2.7,2.3,2.6,2.3,2.5,2.4C2,2.8,1.4,2.9,0.9,2.6c-0.6-0.3-1-1-0.8-1.7 c0-0.1,0.1-0.2,0.1-0.3c0.1-0.2,0.2-0.3,0.4-0.4c0.1,0,0.1-0.1,0.2-0.1c0.2,0,0.5,0,0.7,0.1c0.1,0.1,0.2,0.1,0.3,0.2 c0.4,0.4,0.7,0.8,1,1.3C2.7,1.9,2.7,2.1,2.7,2.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1202",
    transform: "translate(1.492 11.209)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3656",
    className: "st12",
    d: "M1.1,0.7c0,0.1,0,0.1-0.1,0.2c0,0,0,0.1-0.1,0.1C0.8,1.1,0.6,1.1,0.4,1 C0.1,0.9,0,0.7,0,0.4c0,0,0-0.1,0-0.1c0-0.1,0.1-0.2,0.2-0.2c0,0,0.1,0,0.1,0c0.2,0,0.4,0,0.5,0.1c0,0,0.1,0.1,0.1,0.1 C1.1,0.3,1.1,0.4,1.1,0.7C1.1,0.6,1.1,0.6,1.1,0.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3657",
    className: "st13",
    d: "M1.1,0.8C1,0.9,1,0.9,1.1,0.8C0.8,1.1,0.5,1.1,0.3,1C0.1,0.9,0,0.6,0,0.4c0,0,0-0.1,0-0.1 c0-0.1,0.1-0.1,0.1-0.2c0,0,0.1,0,0.1,0c0.1,0,0.2,0,0.3,0.1c0,0,0.1,0,0.1,0.1c0.2,0.2,0.3,0.3,0.4,0.5 C1.1,0.8,1.1,0.8,1.1,0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1203",
    transform: "translate(12.582 11.324)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3658",
    className: "st12",
    d: "M3.9,2.2C3.6,2.9,3.2,3.8,2.2,3.6c-0.1,0-0.2,0-0.3,0c-0.1,0-0.2,0-0.3,0 c-0.5-0.1-1-0.3-1.4-0.8C-0.3,2,0.2,1.2,0.8,0.6C0.8,0.5,0.9,0.4,1,0.4C1.3,0,1.8-0.1,2.2,0C2.8,0.1,3.4,0.5,3.8,1 c0.1,0.1,0.1,0.2,0.1,0.3c0.1,0.2,0,0.4,0,0.6C4,2,3.9,2.1,3.9,2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3659",
    className: "st13",
    d: "M3.5,2.9C3.3,3.5,2.8,3.7,2.2,3.6c-0.1,0-0.2,0-0.3,0c-0.1,0-0.2,0-0.3,0 c-0.5-0.1-1-0.3-1.4-0.8C-0.3,2,0.2,1.2,0.8,0.6C0.8,0.5,0.9,0.4,1,0.4c0.2-0.3,0.5-0.2,0.7-0.1C2.1,0.5,2.5,0.7,2.8,1 C2.9,1.1,3,1.1,3.1,1.2c0.4,0.4,0.5,0.9,0.4,1.4C3.5,2.7,3.5,2.8,3.5,2.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1204",
    transform: "translate(3.604 2.86)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3660",
    className: "st13",
    d: "M3.5,0.8C3.4,1.4,2.1,1.4,1.4,1.4c-0.1,0-0.2,0-0.4,0c-0.2,0-0.5-0.1-0.7-0.2 C0.3,1.1,0.2,1.1,0.1,1C0,1,0,0.9,0,0.8c0.1-0.4,0.5-0.6,0.9-0.7c0.1,0,0.2,0,0.3-0.1C2,0,3.3-0.2,3.5,0.6 C3.5,0.7,3.5,0.7,3.5,0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3661",
    className: "st16",
    d: "M3.5,0.8C3.4,1.4,2.1,1.4,1.4,1.4c-0.1,0-0.2,0-0.4,0c-0.2,0-0.5-0.1-0.7-0.2 C0.6,1,0.9,0.8,1.1,0.7c0.1,0,0.2-0.1,0.3-0.1C2.2,0.6,2.9,0.6,3.5,0.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1205",
    transform: "translate(10.902 0.941)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3662",
    className: "st13",
    d: "M2,0.5C2,0.5,1.9,0.5,2,0.5C1.8,0.7,1.4,0.8,1,0.8c-0.3,0-0.6-0.1-0.8-0.2 C0.1,0.5,0,0.4,0,0.3c0,0,0,0,0,0C0.1,0.1,0.5,0,1,0S1.9,0.2,2,0.5C2,0.4,2,0.4,2,0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3663",
    className: "st16",
    d: "M1.9,0.5C1.8,0.7,1.4,0.8,1,0.8c-0.3,0-0.6-0.1-0.8-0.2c0.3-0.1,0.7-0.2,1.1-0.2 C1.5,0.4,1.7,0.4,1.9,0.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1206",
    transform: "translate(14.805 2.301)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3664",
    className: "st13",
    d: "M1.1,0.2C1.1,0.2,1.1,0.2,1.1,0.2c0,0.1-0.3,0.2-0.5,0.2C0.2,0.4,0,0.3,0,0.2v0v0 C0,0.1,0.3,0,0.5,0S1,0.1,1.1,0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3665",
    className: "st16",
    d: "M1.1,0.2C1.1,0.2,1.1,0.2,1.1,0.2c0,0.1-0.3,0.2-0.5,0.2C0.2,0.4,0,0.3,0,0.2 C0.4,0.2,0.7,0.2,1.1,0.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1207",
    transform: "translate(7.871 1.837)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3666",
    className: "st13",
    d: "M1.1,0.2c0,0.1-0.3,0.2-0.5,0.2c-0.1,0-0.3,0-0.4-0.1C0,0.3,0,0.2,0,0.2v0 C0,0.1,0.3,0,0.5,0C0.7,0,0.9,0.1,1.1,0.2C1,0.2,1.1,0.2,1.1,0.2L1.1,0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3667",
    className: "st16",
    d: "M1.1,0.2c0,0.1-0.3,0.2-0.5,0.2c-0.1,0-0.3,0-0.4-0.1c0.1-0.1,0.3-0.1,0.4-0.2 C0.7,0.1,0.9,0.1,1.1,0.2C1,0.2,1.1,0.2,1.1,0.2L1.1,0.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1208",
    transform: "translate(9.681 3.696)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3668",
    className: "st13",
    d: "M3.5,0.8c0,0.1,0,0.1-0.1,0.2L3.4,1.1c-0.9,0.7-2.2,0.7-3.1,0c0,0,0,0,0,0 C0.2,1,0.1,0.9,0.1,0.9C0,0.8,0,0.8,0,0.7C0.1,0.3,0.4,0.1,0.8,0C0.9,0,1,0,1.1,0c0.7,0,1.4,0.2,2,0.4c0.1,0,0.1,0.1,0.2,0.1 C3.4,0.6,3.5,0.7,3.5,0.8C3.5,0.8,3.5,0.8,3.5,0.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3669",
    className: "st16",
    d: "M3.4,1.1c-0.9,0.7-2.2,0.7-3.1,0c0.1-0.1,0.3-0.3,0.5-0.3c0.1,0,0.2-0.1,0.3-0.1 C1.9,0.7,2.7,0.8,3.4,1.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1209",
    transform: "translate(15.923 4.572)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3670",
    className: "st13",
    d: "M2.4,0.5c0,0.3-0.5,0.5-1.2,0.4c-0.2,0-0.4,0-0.6-0.1C0.2,0.8,0,0.6,0,0.5c0,0,0,0,0,0 C0.1,0.2,0.6,0,1.2,0C1.8,0,2.3,0.2,2.4,0.5C2.4,0.4,2.4,0.4,2.4,0.5C2.4,0.5,2.4,0.5,2.4,0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3671",
    className: "st16",
    d: "M2.4,0.5c0,0.3-0.5,0.5-1.2,0.4c-0.2,0-0.4,0-0.6-0.1c0.3-0.2,0.7-0.3,1-0.4 C1.8,0.4,2.1,0.4,2.4,0.5C2.4,0.4,2.4,0.4,2.4,0.5C2.4,0.5,2.4,0.5,2.4,0.5z"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_3672",
    className: "st7",
    d: "M75.3,96.8L71,95.9l-2.2-0.5l-0.9-0.2l-1-0.2L66.3,95c-0.1,0-0.1-0.1-0.1-0.2l0-0.3L66,93.9 l0-0.4c0-0.4-0.1-0.9-0.1-1.3c0-0.3,0-0.7,0-1c-0.1-0.7-0.1-1.5,0-2.2c0.1-0.9,0.1-1.9,0.1-2.8c0-0.9,0.1-1.8,0.1-2.7l0-0.7l0-0.5 c0.1-0.1,0.3-0.2,0.4-0.3l0.6-0.4c0.2-0.1,0.3-0.3,0.5-0.4l1-0.6l1-0.5c0.6-0.3,1.2-0.5,1.7-0.8c2.3-0.9,4.7-1.4,7.2-1.7l1.3-0.2 c0.6-0.1,1.1-0.1,1.7,0c0.2,0,0.4,0.1,0.6,0.1l0.2,0l0.1,0l0.1,0l0,0c0,0,0-0.1,0,0h0l0,0c0.1,0,0.2,0.1,0.3,0.1 c0.1,0.1,0.2,0.1,0.2,0.2l0.1,0.1l0.4,0.5l0.8,1.1c0.5,0.7,1.1,1.4,1.7,2.1c0.6,0.6,1.1,1.3,1.5,2.1l-0.6,0.5c0,0-0.1,0.1-0.1,0.1 c-0.1,0.1,0,0.4,0.2,0.5c0.3,0.2,0.4,0.3,1,0.1c0.2,0.1,0.3,0.3,0.4,0.5c0.1,0.1,0.2,0.3,0.3,0.4c0.5,0.9,0.8,2,0.6,3.1 c0,0.1,0,0.3-0.1,0.4c0,0.1,0,0.1-0.1,0.1c0,0-0.1,0-0.1-0.1c-0.2-0.4-0.3-0.8-0.3-1.3c0-0.5-0.1-0.9-0.3-1.3 c-0.2-0.3-0.4-0.6-0.7-0.9c-0.1,0-0.1,0-0.2,0c-0.6,0-1.2-0.3-1.5-0.8c-0.2-0.3-0.3-0.6-0.3-0.9c0-0.2,0.1-0.3,0.1-0.4 c0,0,0.1-0.1,0.1-0.1c0-0.1-0.1-0.1-0.1-0.2l-0.2-0.3l-0.5-0.7L84,81.1c-0.6-0.7-1.2-1.4-1.8-2.1L82,78.8c-0.1-0.1-0.1-0.1-0.1-0.1 c0,0-0.1-0.1-0.1,0l-0.6,0c-0.2,0-0.5,0-0.7,0c-0.5,0-1,0.1-1.5,0.1c-1,0.1-1.9,0.3-2.9,0.4c-1.3,0.3-2.5,0.6-3.8,1.1 c-1.4,0.5-2.7,1.1-3.9,1.9c-0.3,0.2-0.6,0.4-0.9,0.6c-0.1,0.1,0,0-0.1,0s0-0.1,0,0.2c0,0.8,0,1.5,0,2.3c0,2-0.1,4-0.1,6 c0,0.5,0,1,0.1,1.5l0.1,0.7c0,0,0,0.1,0,0.1l2.6,0.5c2.5,0.5,4.9,1.1,7.4,1.6c1.5,0.3,3,0.6,4.5,0.9c1.2,0.3,2.4,0.5,3.5,0.8 l1.8,0.4l0.9,0.2c0.2,0,0.4,0.1,0.5-0.1c0-0.1,0.1-0.2,0.1-0.3c0-0.1,0-0.3,0.1-0.4c0-0.3,0-0.6,0-1l0.1,0.2 c-0.2-0.1-0.3-0.3-0.3-0.5c0-0.2,0.1-0.4,0.3-0.5l-0.1,0.2l0.1-1.3c0.1-1.2,0.1-2.4,0.2-3.6v0l0,0c-0.1,0-0.2-0.1-0.2-0.2 c-0.3-0.3,0-0.9,0.3-0.8c0,0,0.1,0.1,0.1,0.1c0,0.1,0,0,0,0c0,0,0.1,0.1,0.1,0.1c0,0,0,0,0,0c0,0,0.1,0.1,0,0.1 c-0.1,0.1-0.2,0.2-0.1,0.1l0.5-1.3l0.1,1.9c0,0.6,0,1.3,0,1.9c-0.1,1-0.1,2-0.1,3l0,1.1l-0.4-0.6c-0.1-0.2-0.1-0.1,0-0.2 c0,0,0,0,0,0l0.3-1l0.1,1.3c0,0.3,0.1,0.6,0.1,0.8l0,0.4c0,0.2,0,0.4,0,0.6c0,0.5-0.3,0.9-0.8,1.1c-0.3,0.1-0.7,0.1-1,0l-0.6-0.1 l-1.1-0.2c-0.8-0.2-1.5-0.3-2.2-0.5C83,98.2,82,98,81,97.8L75.3,96.8L75.3,96.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3673",
    className: "st7",
    d: "M81.5,85.8L81.5,85.8c-0.1,0.1-0.1,0.2-0.2,0.2c-0.1,0.1-0.2,0.2-0.3,0.3 c-0.2,0.2-0.5,0.2-0.7,0.3c-0.3,0-0.6,0-0.9-0.2c-0.2-0.1-0.4-0.3-0.6-0.4c-0.1-0.1-0.2-0.3-0.3-0.4c0-0.1-0.1-0.2-0.1-0.2l0-0.1 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0.1,0.1-0.3,0-0.5-0.1c-0.3-0.1-0.6-0.1-0.9-0.1c-0.3-0.1-0.6-0.1-0.8-0.1l-0.8-0.1l-0.7-0.1 l-0.6-0.1h0c0,0,0,0,0,0l0,0c-0.1,0.1-0.3,0.2-0.5,0.2c-0.2,0-0.4,0-0.5-0.1c-0.3-0.1-0.5-0.3-0.7-0.6l0,0c0,0,0,0,0,0l-0.1,0 c-0.1,0-0.3,0-0.4,0c-0.2,0-0.3,0-0.5-0.1c-0.1,0-0.1,0-0.2-0.1c-0.6-0.1-1.1-0.3-1.7-0.3c-0.3,0-0.6-0.1-0.8-0.2 c-0.3-0.1-0.6-0.2-1-0.3l-0.9-0.2c0,0-0.1,0-0.1-0.1c0,0,0,0,0-0.1c0,0,0,0,0-0.1c0.1-0.1,0.3-0.1,0.4-0.1c0.3,0.1,0.7,0.1,1.1,0.2 l2,0.4c0.3,0.1,0.6,0.1,0.9,0.1l0.8,0.1l0.4,0.1l0.5,0.1l0.2,0.1l0.1,0.1c0.1,0.1,0.1,0.2,0.2,0.3c0.1,0.1,0.2,0.1,0.3,0.1 c0.1,0,0.1,0,0.2-0.1l0.2-0.1l0.1,0l0.1-0.1l2.9,0.4l2.2,0.3c0,0.2,0,0.3,0,0.5c0,0.1,0,0.2,0.1,0.2c0,0.1,0.1,0.2,0.2,0.3 c0.1,0.2,0.3,0.3,0.5,0.4c0.5,0.1,0.9-0.1,1.1-0.5l0.2-0.1c0.1,0,0.1,0,0.2-0.1l0.5,0.1c0.5,0.1,0.9,0.2,1.4,0.3 c0.7,0.2,1.5,0.3,2.2,0.5c0.4,0.1,0.8,0.2,1.3,0.3l1.2,0.3c0.1,0,0.3,0.1,0.4,0.2c0,0,0,0.1,0,0.1c0,0,0,0,0,0c-0.1,0-0.1,0-0.2,0 c-0.3,0-0.6-0.1-0.9-0.1c-0.4-0.1-0.8-0.2-1.1-0.3c-0.1,0-0.2,0-0.3,0c-0.2,0-0.3,0-0.5,0c-0.5-0.1-0.9-0.2-1.4-0.3 c-0.3-0.1-0.6-0.1-0.9-0.2l-0.8-0.1l-0.4-0.1C81.7,85.8,81.6,85.8,81.5,85.8L81.5,85.8L81.5,85.8L81.5,85.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFoodDairy);
export default __webpack_public_path__ + "static/media/icon-food-dairy.365efdc789ed1355237857591971eea2.svg";
export { ForwardRef as ReactComponent };